module.exports = __webpack_public_path__ + "img/the-thinking-traveller-logo-dark.94eb8cb4.svg";